import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { FinancialStatementComponent } from '../component/financial-statement/financial-statement.component';

export enum FS_URLS {
  base = 'financialStatement',
  _workingPaper = 'working-paper',
  _financialsAnalytics = 'financial-analytics',
  _capAccounts = 'capital-accounts',
  _gl = 'general-ledger',
  _tb = 'account-summary',
  _assembly = 'assembly',
  _soi = 'soi',
  _bs = 'balance-sheet',
  _pl = 'profit-loss',
}

const routes: Routes = [
  {
    path: '',
    component: FinancialStatementComponent,
    children: [
      {
        path: '',
        redirectTo: FS_URLS._workingPaper,
        pathMatch: 'full',
      },
      {
        path: FS_URLS._workingPaper,
        component: FinancialStatementComponent,
        children: [
          {
            path: '',
            redirectTo: FS_URLS._gl,
            pathMatch: 'full',
          },
          { path: FS_URLS._gl, component: FinancialStatementComponent },
          { path: FS_URLS._tb, component: FinancialStatementComponent },
          { path: FS_URLS._assembly, component: FinancialStatementComponent },
          { path: FS_URLS._soi, component: FinancialStatementComponent },
        ],
      },
      {
        path: FS_URLS._financialsAnalytics,
        component: FinancialStatementComponent,
        children: [
          {
            path: '',
            redirectTo: FS_URLS._bs,
            pathMatch: 'full',
          },
          { path: FS_URLS._bs, component: FinancialStatementComponent },
          { path: FS_URLS._pl, component: FinancialStatementComponent },
        ],
      },
      {
        path: FS_URLS._capAccounts,
        component: FinancialStatementComponent,
        children: [
          {
            path: '',
            redirectTo: FS_URLS._capAccounts,
            pathMatch: 'full',
          },
          { path: FS_URLS._capAccounts, component: FinancialStatementComponent },
        ],
      },
    ],
  },
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FinancialStatementRoutingModule {
}
